import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  fetchPushEvents,
  fetchPushStats,
  fetchPushSubscriptions,
  fetchUsersWithPush,
  sendTestPush,
  type SendTestPushPayload,
} from '../api/pushNotifications';

export function usePushStats(refetchInterval: number | false = 15_000) {
  return useQuery({
    queryKey: ['admin', 'push', 'stats'],
    queryFn: fetchPushStats,
    refetchInterval,
  });
}

export function usePushEvents(params: {
  status?: string;
  search?: string;
  page?: number;
  page_size?: number;
}) {
  return useQuery({
    queryKey: ['admin', 'push', 'events', params],
    queryFn: () => fetchPushEvents(params),
    refetchInterval: 5_000,
  });
}

export function useUsersWithPush(search: string) {
  return useQuery({
    queryKey: ['admin', 'push', 'users', search],
    queryFn: () => fetchUsersWithPush(search || undefined),
    enabled: search.length >= 2,
  });
}

export function usePushSubscriptions(params: {
  search?: string;
  page?: number;
  page_size?: number;
}) {
  return useQuery({
    queryKey: ['admin', 'push', 'subscriptions', params],
    queryFn: () => fetchPushSubscriptions(params),
  });
}

export function useSendTestPush() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: SendTestPushPayload) => sendTestPush(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'push'] });
    },
  });
}
